<template>
    <div ref="SliderContainer" class="compare-slider swiper-container compare-slider--head">
        <draggable
            class="swiper-wrapper"
            tag="transition-group"
            :component-data="{
              tag: 'div',
              type: 'transition-group',
              name: !drag ? 'flip-list' : null
            }"
            v-model="currentCategory"
            v-bind="dragOptions"
            @start="drag = true"
            @end="drag = false"
            item-key="id"
        >
            <template #item="{ element }">
                <div class="swiper-slide compare-slider__item">
                    <div class="compare-card">
                        <div class="compare-card__head">
                            <a class="compare-card__img" :href="element.url">
                                <img class="compare-card__img-img" :src="element.photo" alt="" loading="lazy">
                            </a>
                            <a class="compare-card__title" :href="element.url">{{ element.name }}</a>
                            <div class="compare-card__price">
                                <span class="price">{{ element.price || 0 }}&nbsp;<i class="rub">₽</i></span></div>
                            <div class="compare-card__info">{{ element.article }}</div>
                        </div>
                    </div>
                </div>
            </template>
        </draggable>
        <div class="swiper-controls">
            <div ref="PrevBtn" class="swiper-button swiper-button-prev" @click="goPrev"></div>
            <div class="swiper-pagination"></div>
            <div ref="NextBtn" class="swiper-button swiper-button-next" @click="goNext"></div>
        </div>
    </div>
</template>

<script>
import draggable from 'vuedraggable'
import {mapState, mapMutations} from "vuex";

export default {
    name: "Head",
    components: {draggable},
    emits: ['nextSlide', 'prevSlide'],
    props: {
        categoryId: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            drag: false,
            transformOptions: {
                transformStep: null,
                currentTransform: 0,
                maxSteps: null,
                currentStep: 0,
            },
        }
    },
    mounted() {
        this.setHeadTransformSettings()
        window.addEventListener('resize', this.setHeadTransformSettings)
    },
    unmounted() {
        window.removeEventListener('resize', this.setHeadTransformSettings)
    },
    computed:{
        dragOptions() {
            return {
                animation: 200,
                group: "description",
                disabled: false,
                ghostClass: "ghost",
                chosenClass: 'chosen',
            };
        },
        currentCategory: {
            get() {
                return this.categories.find(i => i.ID === this.categoryId).items
            },
            set(value) {
                this.changeSorting({catId: this.categoryId, items: value})
            }
        },
        ...mapState({
            categories: state => state.categories
        }),
    },
    methods: {
        goNext() {
            this.nextSlide()
            this.$emit('nextSlide')
        },
        goPrev() {
            this.prevSlide()
            this.$emit('prevSlide')
        },
        setHeadTransformSettings() {
            this.transformOptions.transformStep = this.$refs.SliderContainer.querySelector('.swiper-slide').offsetWidth
            this.transformOptions.maxSteps = this.currentCategory.length <= 4 ? 0 : this.currentCategory.length - 4

            this.$refs.SliderContainer.querySelector('.swiper-wrapper').style.transform = `translate3d(0,0,0)`
            this.transformOptions.currentTransform = 0
            this.transformOptions.currentStep = 0
            this.$refs.PrevBtn.classList.add('swiper-button-disabled')
            if (this.transformOptions.maxSteps === 0)  this.$refs.NextBtn.classList.add('swiper-button-disabled')
        },
        nextSlide() {
            if (this.transformOptions.currentStep !== this.transformOptions.maxSteps) {
                let transformValue = this.transformOptions.currentTransform - this.transformOptions.transformStep
                this.$refs.SliderContainer.querySelector('.swiper-wrapper').style.transform = `translate3d(${transformValue}px,0,0)`
                this.transformOptions.currentTransform = transformValue
                ++this.transformOptions.currentStep

                if (this.$refs.PrevBtn.classList.contains('swiper-button-disabled')) {
                    this.$refs.PrevBtn.classList.remove('swiper-button-disabled')
                }

                if (this.transformOptions.currentStep === this.transformOptions.maxSteps) {
                    this.$refs.NextBtn.classList.add('swiper-button-disabled')
                }
            } else {
                return
            }
        },
        prevSlide() {
            if (this.transformOptions.currentStep !== 0) {
                let transformValue = this.transformOptions.currentTransform + this.transformOptions.transformStep
                this.$refs.SliderContainer.querySelector('.swiper-wrapper').style.transform = `translate3d(${transformValue}px,0,0)`
                this.transformOptions.currentTransform = transformValue
                --this.transformOptions.currentStep

                if (this.$refs.NextBtn.classList.contains('swiper-button-disabled')) {
                    this.$refs.NextBtn.classList.remove('swiper-button-disabled')
                }

                if (this.transformOptions.currentStep === 0) {
                    this.$refs.PrevBtn.classList.add('swiper-button-disabled')
                }
            } else {
                return
            }
        },
        ...mapMutations({
            changeSorting: 'changeItemsSorting'
        })
    }
}
</script>

<style scoped lang="css">

</style>